import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function StickyFloatingCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Mostrar después de scrollear ~600px (pasando el hero section)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-236">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 20
    }} className="fixed bottom-0 left-0 right-0 z-40 p-4 md:p-6 pointer-events-none" data-id="element-237">
          <div className="max-w-4xl mx-auto bg-white/85 backdrop-blur-md border border-brand-sage/20 shadow-2xl rounded-2xl p-4 flex flex-col sm:flex-row items-center justify-between gap-4 pointer-events-auto" data-id="element-238">
            <div className="flex flex-col items-center sm:items-start" data-id="element-239">
              <span className="text-xs font-bold text-brand-red uppercase tracking-wider animate-pulse" data-id="element-240">
                Oferta Limitada
              </span>
              <div className="flex items-baseline gap-2" data-id="element-241">
                <span className="text-2xl font-black text-brand-sage" data-id="element-242">
                  $19.990
                </span>
                <span className="text-sm text-brand-charcoal/50 line-through" data-id="element-243">
                  $138.000
                </span>
              </div>
            </div>
            <a href="https://bienestardigital.click/cart/add?id=43120004464729&quantity=1" className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-brand-coral hover:bg-[#c96b43] text-white font-bold py-3 px-8 rounded-full text-base transition-transform hover:scale-105 shadow-[0_0_15px_rgba(239,118,116,0.4)]" data-id="element-244">
              QUIERO ACCEDER
              <ArrowRight className="w-4 h-4" data-id="element-245" />
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}